import {push} from 'notivue';
import type {AxiosError} from 'axios';

type LaravelErrorResponse = {
    message?: string;
    errors?: Record<string, string[]>;
};

export function getApiErrorMessage(error: unknown, fallbackMessage = 'There was an error'): string {
    const err = error as AxiosError;
    const data = err?.response?.data as LaravelErrorResponse | undefined;

    if (data?.errors) {
        const messages = Object.values(data.errors).flat().filter(Boolean);

        if (messages.length > 0) {
            return messages.join(' ');
        }
    }

    return data?.message ?? fallbackMessage;
}

export function handleApiError(error: unknown, fallbackMessage = 'There was an error') {
    push.error({message: getApiErrorMessage(error, fallbackMessage)});
}
